// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1kKMA","file":"styles_file__28h3X"};